"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import '../../styled-system/css/css.mjs';
import '../../styled-system/helpers.mjs';
import { sva } from '../../styled-system/css/sva.mjs';

const simpleInputRecipe = sva({
  className: "simple-input",
  slots: ["row", "cell", "title", "input", "textarea"],
  base: {
    row: {
      transition: "colors"
    },
    cell: {
      _focusWithin: {
        bg: "gray.2"
      },
      "&:has(.simple-input__input)": {
        pt: "0.35rem",
        pb: "0.35rem"
      },
      "&:has(.simple-input__textarea)": {
        p: "0"
      }
    },
    title: { whiteSpace: "nowrap" },
    input: {
      bg: "transparent",
      border: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      h: "9",
      px: "4",
      transition: "all",
      transitionDuration: "faster",
      rounded: "md",
      color: "black",
      _focus: {
        outline: "none"
      },
      _disabled: {
        color: "neutral.7",
        _placeholder: {
          color: "neutral.7"
        }
      }
    }
  },
  variants: {
    disabled: {
      true: {
        row: {
          bg: "neutral.1",
          color: "neutral.9"
        }
      },
      false: {}
    }
  },
  defaultVariants: {
    disabled: false
  }
});

export { simpleInputRecipe };
